import {
    GET_EXITS_SUCCESS
} from './constants';

const initialQuestionsState = {};

/**
 *
 * @param state
 * @param action
 * @returns {{}&{exits: (*|ExitsDiagram.state.exits|{data, seriesName}|exits|result.exits|Array)}}
 */
const statisticsQuestionsReducer = ( state = initialQuestionsState, action ) => {
    switch ( action.type ) {
        case GET_EXITS_SUCCESS: {
            return {
                ...state,
                exits: action.exits
            };
        }
        default: {
            return state;
        }
    }
};

export { statisticsQuestionsReducer as questionsstst };